module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7BdEz"))).then(() => parcelRequire('8rm4T'));